/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seo_Profile_TitleInputs */

const he_seo_profile_title = /** @type {(inputs: Seo_Profile_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`פרופיל - Pricedrop`)
};

const en_seo_profile_title = /** @type {(inputs: Seo_Profile_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profile - Pricedrop`)
};

/**
* | output |
* | --- |
* | "Profile - Pricedrop" |
*
* @param {Seo_Profile_TitleInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const seo_profile_title = /** @type {((inputs?: Seo_Profile_TitleInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Profile_TitleInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_seo_profile_title(inputs)
	return en_seo_profile_title(inputs)
});